export default {"src":"/_next/static/image/public/images/referral_order_conf_banner.a17b743b16035d1b63d95300c872724d.svg","height":152,"width":961};